var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10H14C13.4696 10 12.9609 10.2107 12.5858 10.5858C12.2107 10.9609 12 11.4696 12 12V28C12 28.5304 12.2107 29.0391 12.5858 29.4142C12.9609 29.7893 13.4696 30 14 30H26C26.5304 30 27.0391 29.7893 27.4142 29.4142C27.7893 29.0391 28 28.5304 28 28V16L22 10ZM17.998 22.768H16.895V26.042H15.978V22.768H14.893V22H17.998V22.768ZM20.723 26.042L20.358 25.311C20.208 25.029 20.112 24.819 19.999 24.585H19.986C19.903 24.818 19.801 25.028 19.674 25.311L19.339 26.042H18.294L19.465 23.997L18.336 22H19.386L19.74 22.738C19.861 22.983 19.95 23.181 20.046 23.409H20.059C20.155 23.151 20.233 22.971 20.335 22.738L20.676 22H21.719L20.58 23.973L21.778 26.042H20.723ZM25.107 22.768H24.003V26.042H23.086V22.768H22.001V22H25.106L25.107 22.768ZM22 17H21V12L26 17H22Z",
    fill: "#14B8A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFile);
export default __webpack_public_path__ + "static/media/text-file.3035a0b57aa3dd9080659a5ce612829a.svg";
export { ForwardRef as ReactComponent };